import { httpLogPageLoadId } from '@cvent/nucleus-networking';

export default function redirectToErrorPage(rootPath, eventId, environment, httpLogRequestId) {
  const errorUrl = `${rootPath}/error?httpLogPageLoadId=${httpLogPageLoadId}` +
                   `&httpLogRequestId=${httpLogRequestId || ''}` +
                   `&errorDateTime=${(new Date()).toString()}` +
                   `&isoDateTime=${(new Date()).toISOString()}` +
                   `&eventId=${eventId}` +
                   (environment ? `&environment=${environment}` : '');
  window.location = encodeURI ? encodeURI(errorUrl) : errorUrl;
}
